<script setup>
/**
 * FormControlMBasketOrdersSessionLog
 * Composition-based wrapper for the One-To-Many relationship controller.
 * Restricts visibility dynamically based on the application's global betaMode status.
 */
import {computed, onMounted} from 'vue'
import FormControlTypeRelationshipOneToMany from "@/common/form-control-type/FormControlTypeRelationshipOneToMany.vue"
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
})

const appStore = useAppStore()

const betaMode = computed(() => appStore.betaMode)

onMounted(() => {
    /**
     * If the environment is not running in betaMode,
     * instantly drop visibility from the form configuration layer.
     */
    if (!betaMode.value && props.field) {
        props.field.hidden = true
    }
})
</script>

<template>
    <FormControlTypeRelationshipOneToMany v-bind="$props" v-if="!field.hidden"/>
</template>